import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  mobShow: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  mobHide: {
    display: 'block',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  articleHeading: {
    fontWeight: 800,
    fontSize: '5.25rem',
    lineHeight: '5.1875rem',
    textTransform: 'uppercase',
    [theme.breakpoints.down('sm')]: {
      fontSize: '3rem',
      lineHeight: '3.325rem',
    },
  },
  articleText: {
    fontWeight: 400,
    fontSize: '1.25rem',
    lineHeight: '1.705',
    letterSpacing: '0.375',
    textTransform: 'uppercase',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
      lineHeight: '1.36rem',
    },
  },
  articleSecondary: {
    width: '60%',
    marginLeft: 'auto',
    marginRight: 'auto',
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: '1.25rem',
    lineHeight: '1.5rem',
    opacity: '0.7',

    [theme.breakpoints.down('md')]: {
      width: '70%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      fontSize: '1.125rem',
      lineHeight: '1.36rem',
    },
  },
  heartIcon: {
    width: '4.1875rem',
    height: '4.1875rem',
  },
}))

export default useStyles
